export default __webpack_public_path__ + "static/media/005-anchor-1.89ab33ad.png";